<template>
    <button @click="changeOrderBy">
        {{title}} <em v-html="sign"></em> 
        <i v-if="property == $parent.apartments.orderBy.property" 
           :class="{ arrdown: orderBy.type == 'asc', arrup: orderBy.type == 'desc' }"></i>   
    </button>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            sign: {
                type: String
            },
            property: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                orderBy: {
                    property: this.property,
                    type: "asc"
                }
            }
        },
        methods: {
            changeOrderBy() {
                if (this.$parent.apartments.orderBy.property == this.orderBy.property) {
                    this.orderBy.type = this.orderBy.type == 'asc' ? 'desc' : 'asc';
                }
                else {
                    this.orderBy.type = 'asc';
                }
                
                this.$emit("orderByChanged", this.orderBy);
            }
        }
    }
</script>